import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const rateCard = api(async function rateCard({ id }) {
    return query(
        gql`
            query GetRateCard($id: String!) {
                rateCard(id: $id) {
                    id
                    name
                    description
                    skillMapId
                    skillMapName
                    skillMapIsArchived
                    currency
                    defaultRate
                    hoursPerDay
                    lines {
                        tradeId
                        tradeName
                        hourlyRate
                        minimumBillingPeriod
                        notes
                        isNew
                        isOrphaned
                        mode
                        fixedAnnualAmount
                        contractedDaysPerYear
                        skillOverrides {
                            skillId
                            hourlyRate
                        }
                    }
                    modifiers {
                        id
                        name
                        value
                        type
                        scope {
                            kind
                            value
                        }
                        applyTo
                    }
                    isArchived
                    needsReview
                    created
                    modified
                }
            }
        `,
        { id },
        { returns: "rateCard" }
    )
})
